// @flow
import * as React from "react";
import {reisy, use} from "reisy";
import {defineMessages, injectIntl, FormattedMessage} from "react-intl";
import Navigation from "../navigation/index.js";
import Heading from '../components/heading';

const messages = defineMessages({
	title: {
		id: "forward.title",
		defaultMessage: "Forwarding",
	},
	message: {
		id: "forward.message",
		defaultMessage: 'You are being forwarded to: {href}',
	}
});

export const styles = reisy`
@namespace Forward;

JackInTheBox: $Settings.JackInTheBox;

Forward {
	@extends Helpers.Fullscreen;
}
Contain {
	@extends Helpers.Contain;
}

Content {
	max-width: 300px;
	margin: 4em auto 3em;
	text-align: center;

	p {
		font-family: $Fonts.aside;
	}

	a {
		color: inherit;
	}
}

Title {
	font-family: $Fonts.title;
	font-size: 3rem;
}
`;

type Props = {
	type: number;
	message: string;
};

const Forward = ({intl: {formatMessage}, href}: Props) => (
	<div {...use(styles.Forward, styles.JackInTheBox && styles.Contain)}>
		<Navigation />
		<div {...use(styles.Content)}>
			<Heading lvl={1} {...use(styles.Title)}>{formatMessage(messages.title)}</Heading>
			<p><FormattedMessage {...messages.message} values={{href: <a href={href}>{href}</a>}} /></p>
			<script>{window.location = href}</script>
		</div>
	</div>
);
export default injectIntl(Forward);



// WEBPACK FOOTER //
// ./lib/screens/forward.js